import { Controller } from "stimulus";

window.DataTable = require('datatables.net');
window.DataTable = require('datatables.net-responsive');

export default class extends Controller {
  connect() {
    this.bind();
  }

  bind() {
    $('#songs').DataTable({
      language: {
        paginate: {
          previous: "Previous",
          next: "Next"
        }
      },
      "lengthMenu": [ 20, 50, 100 ],
      "responsive": true,
      "autoWidth": false,
      "columnDefs": [
        { "responsivePriority": 1, "targets": [0,2] },
        { "responsivePriority": 2, "targets": [1] },
        // { "responsivePriority": 3, "targets": [1] },
        { "width": "50%", "targets": [0] },
        { "width": "90px", "targets": [2] },
        // { "width": "100px", "targets": [3] }
      ]
    })
  }
}

